// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"e531a940","30":"b7077dd4","53":"2d7ded6b","148":"86d80839","172":"bd4474fd","213":"b1ad6cfd","239":"670e649d","448":"1e6eed2f","453":"3b70cbbc","520":"ff63ddf7","606":"460a7a67","655":"9603ad56","817":"5a21aaf5","967":"7742f58b"}[chunkId] + ".chunk.js";
};